import { useEffect, useState, useContext } from "react";
import Button from "../components/Button";
import TextInput from "../components/TextInput";
import { ReactComponent as IllusStep } from "../img/illustrations/location.svg";
import { ReactComponent as IconTarget } from "../img/target.svg";
import { useSwiper } from "swiper/react";
import { useMediaQuery } from 'react-responsive';

import SimulationContext from "../contexts/Simulation";
import useFetch from "../hooks/useFetch";

const LocationHelper = ({ setLocation }) => {
  const [apiUrl, setApiUrl] = useState(null);
  const [doFetchCP, responseCP] = useFetch(apiUrl);

  const handleGetLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      setApiUrl(`${process.env.REACT_APP_SIM_API_URL}/cp/${position.coords.latitude}/${position.coords.longitude}`);
    });
  };

  useEffect(() => {
    if (apiUrl)
      doFetchCP({headers: {
        'Content-Type': 'application/json',
        'X-Auth-Token': process.env.REACT_APP_SIM_API_KEY
      }});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiUrl]);

  useEffect(() => {
    if (responseCP)
      setLocation(responseCP.zip_code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseCP]);

  return (
    <IconTarget onClick={handleGetLocation} style={{cursor: 'pointer'}}/>
  )
}

const LocationStep = ({ step, initialProps }) => {
  const [simParams, setSimParams] = useContext(SimulationContext);
  const [location, setLocation] = useState(initialProps.zip ?? '');
  const [apiUrl, setApiUrl] = useState(null);
  const [doFetchLocation, responseLocation] = useFetch(apiUrl);
  const swiper = useSwiper();
  const [touched, setTouched] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const txtChangeHandler = (e) => {
    if (e.target.value.match(/^[0-9]?[0-9A-Ba-b]?[0-9]{0,3}$/))
      setLocation(e.target.value);
  };

  useEffect(() => {
    if (!touched) {
      setTouched(true);
      return;
    }
    const valid = !!location.match(/^[0-9][0-9A-Ba-b][0-9]{3}$/);
    if (valid)
      setApiUrl(`${process.env.REACT_APP_SIM_API_URL}/cp/${location}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (apiUrl) {
      doFetchLocation({headers: {
        'Content-Type': 'application/json',
        'X-Auth-Token': process.env.REACT_APP_SIM_API_KEY
      }});
      setSimParams({
        ...simParams, 
        allowSlideNext: false, 
        validSteps: (simParams.validSteps & ~(1 << step)) | (0 << step)
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiUrl]);

  useEffect(() => {
    if (responseLocation)
    {
      setSimParams({
        ...simParams, 
        location: responseLocation,
        allowSlideNext: true, 
        validSteps: (simParams.validSteps & ~(1 << step)) | (1 << step)
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseLocation]);

  return (
    <div className="content location">
      <IllusStep className="main-illus"/>
      <h3>Où le soleil brille-t-il pour vous ?</h3>
      <div className="sub">Indiquez votre code postal pour qu'on puisse calculer précisément l'ensoleillement de votre toiture.</div>
      <TextInput 
        type="tel" 
        After={() => <LocationHelper setLocation={setLocation}/>} 
        onchange={txtChangeHandler} 
        value={location}
        placeholder={isMobile ? "Code Postal" : "Rien de louche, c'est juste pour affiner votre estimation, promis !"}
      />
      <Button variant='yellow' onclick={() => swiper.slideNext()}>Valider</Button>
    </div>
  )
}

export default LocationStep;